import * as sentryInterface from "./SentryInterface";

export function setup() {
  if (process.env.NODE_ENV !== "development") {
    sentryInterface.config(
      "https://534ef27679d6480ebb808e666aa795cb@sentry.io/5181449",
      process.env.NODE_ENV === "development" ? "staging" : "production",
      process.env.REACT_APP_VERSION
    );
  }
}
